exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".blue__icheckbox_square-blue--H6Hdg{display:inline-block;*display:inline;vertical-align:middle;margin:0;padding:0;width:22px;height:22px;background:url(" + require("./blue.png") + ") no-repeat;border:none;cursor:pointer;border-radius:3px;background-position:0 0}.blue__icheckbox_square-blue--H6Hdg.blue__checked--23alN{background-position:-48px 0}@media (-webkit-min-device-pixel-ratio:1.25),(min-resolution:120dpi){.blue__icheckbox_square-blue--H6Hdg{background-image:url(" + require("./blue@2x.png") + ");background-size:240px 24px}}", ""]);

// exports
exports.locals = {
	"icheckbox_square-blue": "blue__icheckbox_square-blue--H6Hdg",
	"checked": "blue__checked--23alN"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":false}!./src/styles/icheck/square/blue.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":false}!./src/styles/icheck/square/blue.css
// module chunks = 1